export const RoutePaths = {
  BasePath: '/',
  CladdingPath: '/cladding',
  MeasurementsPath: '/measurements',
  FramesPath: '/frames',
  ExtrasPath: '/extras',
  SummaryPath: '/summary',
};
